import React from 'react';
import styled from 'styled-components';
import * as AppActions from '../../AppActions';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import qs from 'query-string';
import {Button} from 'antd';
import * as Config from '../../../data.json';

export default function SealDetailPage(props) {
  const [seal, setSeal] = React.useState(null);
  const [badge, setBadge] = React.useState(null);
  const {uid, inapp = false} = qs.parse(props.location.search);

  React.useEffect(() => {
    async function fetchData() {
      try {
        AppActions.setLoading(true);
        const sealTag = await JStorage.fetchOneDocument('seal', {uid});
        setSeal(sealTag);
        AppActions.setLoading(false);
        const badgeTag = await JStorage.fetchOneDocument('badge', {
          owner: sealTag.owner,
        });
        setBadge(badgeTag);
      } catch (ex) {
        console.warn('SealDetailPage ex', ex);
        alert('User not found!');
      } finally {
        AppActions.setLoading(false);
      }
    }

    fetchData();
  }, [uid]);

  if (!seal) {
    return <Wrapper />;
  }

  return (
    <Wrapper>
      <img
        src={seal.image || '/images/site-logo.png'}
        alt="seal"
        className="avatar"
      />
      <div className="content">
        <div style={{color: '#888'}}>{seal.uid}</div>
        <h2 className="name">{seal.name}</h2>
        <div className="description">{seal.description}</div>
        {seal.detail_info?.html && (
          <div
            className="detail-info"
            dangerouslySetInnerHTML={{__html: seal.detail_info.html}}
          />
        )}

        {badge && (
          <Button
            size="large"
            type="link"
            style={{marginTop: 15, paddingBottom: 0}}
            onClick={(e) =>
              AppActions.navigate(`/badge/?owner=${badge.owner}`)
            }>
            {badge.seal_action_display || '查看創作者'}
          </Button>
        )}
      </div>

      {!inapp && (
        <div className="verify">
          <Button
            type="primary"
            size="large"
            onClick={() => {
              let deepLinkUrl = `${Config.mobileAppHost}://seal-verify?uid=${uid}`;
              window.open(deepLinkUrl);
            }}>
            驗證
          </Button>
          <div className="hint">
            * 驗證過程使用NFC Badge App, 請至以下連結安裝:
          </div>
          <div className="links">
            <Button type="link">iOS</Button>
            <Button type="link">Android</Button>
          </div>
        </div>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: #eee;
  padding: 20px;
  min-height: 100vh;

  & > img.avatar {
    display: block;
    margin: 0 auto;
    width: 160px;
    height: 160px;
    border-radius: 50%;
    border: 3px solid white;
    box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.25);
    object-fit: cover;
    align-self: center;
    transform: translateY(50%);
    background-color: white;
  }

  & > .content {
    max-width: 720px;
    margin: 0 auto;
    border-radius: 16px;
    padding: 100px 20px 20px 20px;
    background-color: white;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;

    & > h2.name {
      font-size: 24px;
      margin: 0;
    }

    & > div.description {
      color: #888;
      max-width: 360px;
    }

    & > div.detail-info {
      margin-top: 10px;
      max-width: min(100% - 40px, 480px);
    }

    & > .social-items {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      & > * {
        margin: 5px;

        & span {
          display: inline-block;
          margin-left: 10px;
        }
      }
    }
  }

  & > .verify {
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    & > .hint {
      margin-top: 20px;
      color: #888;
    }
    & > .links {
      display: flex;
      justify-content: center;
    }
  }

  &#rev-badge-detail > .content > div.detail-info img {
    max-width: 100%;
  }
`;
